angular.module('bribac.components.insuranceSubscriberEditor', [
    'bribac.values',
    'bribac.translations',
    'bribac.services.api'
])
    .component('insuranceSubscriberEditor', {
        bindings: {
            editableInsuranceSubscriber: '<',
            saveCallback: '&',
            cancelCallback: '&',
            isSubmitting: '<',
        },
        templateUrl: 'insurance-subscriber-editor-component.html',
        controller: 'InsuranceSubscriberEditorCtrl'
    })
    .controller('InsuranceSubscriberEditorCtrl', function (
        $scope,
        api,
        KINDS,
        permissions,
        FLAVOUR,
        US_STATES
    ) {
        const $ctrl = this;

        $ctrl.flavour = FLAVOUR
        $ctrl.stateOptions = US_STATES

        $ctrl.permissions = permissions;

        $ctrl.saveInsuranceSubscriberData = function () {
            const $form = $ctrl.form

            if ($form._submitting) return

            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields'
                return
            }

            if (!($ctrl.editableInsuranceSubscriber.mainGroupsIds || []).length) {
                $form._submitError = 'At least one main group is required';
                return;
            }

            $form._submitSuccess = ''
            $form._submitError = ''

            $ctrl.editableInsuranceSubscriber.mainGroupsIds = ($ctrl.editableInsuranceSubscriber.mainGroupsIds || [])
                .map(group => group.id);

            $ctrl.isSubmitting = true;

            $ctrl.saveCallback({
                data: $ctrl.editableInsuranceSubscriber,
            }).finally(() => {
                $ctrl.isSubmitting = false;
            });

        };

        $ctrl.cancelInsuranceSubscriberForm = function () {
            $ctrl.cancelCallback();
        };

        function initializeEditableInsuranceSubscriber() {
            if (!$ctrl.editableInsuranceSubscriber) {
                $ctrl.editableInsuranceSubscriber = {
                    lastName: '',
                    firstName: '',
                    middleName: '',
                    city: '',
                    state: '',
                    zip: '',
                    dateOfBirth: '',
                    gender: '',
                    mainGroupsIds: []
                };
            } else if (!$ctrl.editableInsuranceSubscriber.mainGroupsIds) {
                $ctrl.editableInsuranceSubscriber.mainGroupsIds = [];
            }
        }

        $ctrl.onDateOfBirthChange = function () {
          if (!$ctrl.editableInsuranceSubscriber.dateOfBirth) return;

          // First check basic format with regex
          if (!$ctrl.editableInsuranceSubscriber.dateOfBirth.match(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/)) {
            $ctrl.editableInsuranceSubscriber.dateOfBirth = null;
            return;
          }

          // Then check if it's a valid date (e.g., not Feb 30 or Apr 31)
          const dateComponents = $ctrl.editableInsuranceSubscriber.dateOfBirth.split('-');
          const year = parseInt(dateComponents[0], 10);
          const month = parseInt(dateComponents[1], 10);
          const day = parseInt(dateComponents[2], 10);

          // Create a date and check if it matches what was entered
          const date = new Date(year, month - 1, day); // JS months are 0-indexed

          if (date.getFullYear() !== year ||
              date.getMonth() + 1 !== month ||
              date.getDate() !== day) {
            // The date was invalid (e.g., Feb 30 would become March 2)
            $ctrl.editableInsuranceSubscriber.dateOfBirth = null;
          }
        };

        function reload() {
            const filter = $ctrl.organization ? `?organization=${$ctrl.organization.id}` : '';

            $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter)
                .then(function (response) {
                    $ctrl.mainGroups = response.data.list;

                    initializeEditableInsuranceSubscriber();

                    if (!$ctrl.editableInsuranceSubscriber.mainGroupsIds) {
                        $ctrl.editableInsuranceSubscriber.mainGroupsIds = [];
                    }

                    const availableIds = $ctrl.mainGroups.map(group => group.id);
                    $ctrl.editableInsuranceSubscriber.mainGroupsIds = $ctrl.editableInsuranceSubscriber.mainGroupsIds.filter(id => availableIds.includes(id));
                })
        }

        $scope.$watch('$ctrl.organization', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                reload();
            }
        });

        $ctrl.$onInit = function () {
            initializeEditableInsuranceSubscriber();
            reload();
        };
    });